export default "__VITE_ASSET__WBDO33ff__"